"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchByTerms = searchByTerms;
function searchByTerms({ data, query, getSearchBase, getId, additionalSort, }) {
    const trimmedQuery = query.trim();
    if (trimmedQuery) {
        const searchTerms = trimmedQuery.split(" ").filter(Boolean);
        const result = [];
        searchTerms.forEach((term) => {
            data.forEach((item) => {
                const searchBase = getSearchBase(item);
                const isMatch = searchBase.toLowerCase().includes(term.toLowerCase());
                if (isMatch) {
                    const existing = result.find((r) => getId(r.item) === getId(item));
                    if (existing) {
                        existing.count += 1;
                    }
                    else {
                        result.push({ item, count: 1 });
                    }
                }
            });
        });
        // Sort by how many terms match, then by custom function
        result.sort((a, b) => {
            const sortResult = b.count - a.count;
            if (sortResult === 0 && additionalSort) {
                return additionalSort(b.item, a.item);
            }
            return sortResult;
        });
        return result.map((r) => r.item);
    }
    return data;
}
//# sourceMappingURL=searchByTerms.js.map